import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { toast } from 'sonner';
import { ApiError } from './api';

/** Mostra erro do servidor no campo apontado (details.field) ou como toast. */
export function handleFormError<T extends FieldValues>(err: unknown, setError?: UseFormSetError<T>): void {
  if (err instanceof ApiError && err.field && setError) {
    setError(err.field as Path<T>, { message: err.message });
    return;
  }
  toast.error(err instanceof ApiError ? err.message : 'Algo deu errado. Tente novamente.');
}
